import React, { useState, useEffect } from 'react';
import login from '../assets/img/login.webp'
import logo from '../assets/img/logo.jpg'
import '../assets/css/login.css'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { BASE_URL } from '../BaseUrl/Baseurl'
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [validationErrors, setValidationErrors] = useState({});
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);


    useEffect(() => {
        const loginData = localStorage.getItem('LoginData');
        if (loginData) {
            navigate("/dashboard");
        }
    }, [navigate]);

    const handleLoginClick = async (e) => {
        e.preventDefault();

        let formValidationErrors = {};
        if (!email) {
            formValidationErrors.email = "Email is required";
        }
        if (!password) {
            formValidationErrors.password = "Password is required";
        }

        if (Object.keys(formValidationErrors).length !== 0) {
            setValidationErrors(formValidationErrors);
            return;
        }

        const loginData = { email, password };
        console.log("login data", loginData)

        try {
            const response = await axios.post(`${BASE_URL}login??type=live`, loginData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
            });

            console.log("loging response", response.data)

            if (response.data.status === "RC200") {
                toast.success("You Login successfully!");

                const userData = {
                    token: response.data.data.token,
                    name: response.data.data.name,
                    email: response.data.data.email,
                    role: response.data.data.role
                };

                console.log("userData:", userData);

                //   localStorage.setItem("token", JSON.stringify(response.data.token));
                localStorage.setItem('LoginData', JSON.stringify(userData));
                localStorage.setItem("token", JSON.stringify(response.data.token));

                navigate("/dashboard");
            } else {
                toast.error("Invalid credentials, please try again.");
            }
        } catch (error) {
            console.error('Error during login:', error);
        }
    };


    return (
        <div>
            <ToastContainer></ToastContainer>

            <section className="container-fluid full-height">

                <div className="row login-section">
                    {/* Left Side - Image */}
                    <div className="col-lg-6 col-md-6 d-none d-md-block p-0">
                        <img src={login} alt="login-img" className="img-fluid login_img" />
                    </div>

                    {/* Right Side - Form */}
                    <div className="col-lg-6 col-md-6 col-12 d-flex align-items-center justify-content-center p-4">
                        <div className="w-100" style={{ maxWidth: '400px' }}>
                            <img src={logo} alt="logo" className="img-fluid mx-auto d-block mb-3" />
                            <h3 className='signin mt-4'>Sign in</h3>
                            <p className='signin_text'>Sign in to your account to start using ByKit</p>
                            <form onSubmit={handleLoginClick} className="mt-4">
                                <div className="mt-3">
                                    <label className="form-label signin_label">Email</label>
                                    <input
                                        name="email"
                                        type="email"
                                        className="form-control py-2 signin_input"
                                        placeholder="Enter Your Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                    {validationErrors.email && (
                                        <small className="text-danger">{validationErrors.email}</small>
                                    )}
                                </div>
                                <div className="mt-3 position-relative">
                                    <label className="form-label signin_label">Password</label>
                                    <input
                                        name="password"
                                        type={showPassword ? "text" : "password"}
                                        className="form-control py-2 signin_input"
                                        placeholder="Enter Your Password"
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        style={{
                                            position: "absolute",
                                            top: "68%",
                                            right: "10px",
                                            transform: "translateY(-50%)",
                                            border: "none",
                                            background: "transparent",
                                            cursor: "pointer",
                                            padding: 0,
                                        }}
                                        aria-label={showPassword ? "Hide password" : "Show password"}
                                    >
                                        {showPassword ? "🙈" : "👁️"}
                                    </button>
                                    {validationErrors.password && (
                                        <small className="text-danger">{validationErrors.password}</small>
                                    )}
                                </div>

                                <Link className='text-decoration-none' to='/forgatepassword'>
                                    <p className="text-end mt-3 forgate_text">Forgot Password?</p>
                                </Link>
                                <button className="btn btn-dark w-100 mt-3 py-2">Sign In</button>
                                <div className="auth-footer mt-4">&copy; {new Date().getFullYear()} ByKit, All rights reserved.</div>
                            </form>
                        </div>
                    </div>
                </div>

            </section>
        </div>
    )
}

export default Login